module.exports = __webpack_public_path__ + "static/img/more-6.0cfc5882.png";